export default {
    data(){
        return{
            savedConditionsCopy: [],
        }
    },
    computed: {
        savedConditions(){
            return this.$store.getters["node/conditions"]
        },
    },
    mounted(){
        this.savedConditionsCopy = this.savedConditions
    },
    methods: {
        onConditionChange(e) {
            this.newConditionId = e.id
        }

        // NEED TO DELETE IF PAGINATION WILL BE REMOVED
        // onIntersect() {
        //     console.log("loading data");
        // },
    }
  }
  